import React, { useEffect, useState } from 'react';
import { SimpleGrid, Select, Input } from '@chakra-ui/react';
import AxiosInstance from '../../api/AxiosInstance';

interface Props {
  onPerfilSeleccionado: (perfil: any) => void;
  initialCurp?: string;
}

const SelectorPerfilUsuario: React.FC<Props> = ({ onPerfilSeleccionado, initialCurp = '' }) => {
  const [perfiles, setPerfiles] = useState<any[]>([]);
  const [curpSeleccionado, setCurpSeleccionado] = useState(initialCurp);
  const [nombreCompleto, setNombreCompleto] = useState('');
  const [curp, setCurp] = useState('');
  const [direccion, setDireccion] = useState('');

  useEffect(() => {
    AxiosInstance.get('/usuario/perfil')
      .then((res:any) => setPerfiles(res.data))
      .catch(() => setPerfiles([]));
  }, []);

  useEffect(() => {
    if (initialCurp) {
      const perfil = perfiles.find((p) => p.curp === initialCurp);
      if (perfil) {
        actualizarCampos(perfil);
      }
    }
  }, [perfiles, initialCurp]);

  const actualizarCampos = (perfil: any) => {
    const nombre = `${perfil.nombre} ${perfil.primerApellido || ''} ${perfil.segundoApellido || ''}`;
    setNombreCompleto(nombre.trim());
    setCurp(perfil.curp || '');
    setDireccion(perfil.direccion || '');
    onPerfilSeleccionado(perfil);
  };

  const handleSelectChange = (val: string) => {
    setCurpSeleccionado(val);
    const perfil = perfiles.find((p) => p.curp === val);
    if (perfil) actualizarCampos(perfil);
  };

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={4}>
      <Select
        placeholder="Buscar por CURP"
        value={curpSeleccionado}
        onChange={(e) => handleSelectChange(e.target.value)}
      >
        {perfiles.map((p) => (
          <option key={p.id} value={p.curp}>{p.curp}</option>
        ))}
      </Select>

      <Input value={nombreCompleto} placeholder="Nombre completo" isReadOnly />
      <Input value={curp} placeholder="CURP" isReadOnly />
      <Input value={direccion} placeholder="Dirección del perfil" isReadOnly />
    </SimpleGrid>
  );
};

export default SelectorPerfilUsuario;
